<script setup lang="ts">
import type { VesselInfo } from '@/composables/useVesselLayer'

const props = defineProps<{ data: VesselInfo }>()
const emit = defineEmits<{ close: [] }>()

function fmtDate(iso: string | null): string {
  if (!iso) return '—'
  return new Date(iso).toLocaleString('vi-VN', { dateStyle: 'short', timeStyle: 'short' })
}
</script>

<template>
  <div class="dvp-section-title">
    TÀU CẬP BẾN
    <button class="dvp-close-btn" @click="emit('close')" title="Đóng">✕</button>
  </div>
  <div class="dvp-detail-block">
    <div v-if="data.shipName" class="dvp-detail-row">
      <span class="dvp-detail-key">Tên tàu</span>
      <span class="dvp-detail-val">{{ data.shipName }}</span>
    </div>
    <div class="dvp-detail-row">
      <span class="dvp-detail-key">Chuyến</span>
      <span class="dvp-detail-val font-mono">{{ data.shipVoy }} / {{ data.shipYear }}</span>
    </div>
    <div class="dvp-detail-row">
      <span class="dvp-detail-key">Cầu</span>
      <span class="dvp-detail-val">{{ data.berth }}</span>
    </div>
    <div v-if="data.ata" class="dvp-detail-row">
      <span class="dvp-detail-key">ATA</span>
      <span class="dvp-detail-val">{{ fmtDate(data.ata) }}</span>
    </div>
    <div v-else-if="data.eta" class="dvp-detail-row">
      <span class="dvp-detail-key">ETA</span>
      <span class="dvp-detail-val">{{ fmtDate(data.eta) }}</span>
    </div>
    <div v-if="data.etd" class="dvp-detail-row">
      <span class="dvp-detail-key">ETD</span>
      <span class="dvp-detail-val">{{ fmtDate(data.etd) }}</span>
    </div>
  </div>
</template>
